/**
 * Field types supported by FormFieldRenderer — use in V2 Studio form builder only.
 * (Renderer supports more; these are the common dashboard form controls.)
 */
export const STUDIO_V2_FORM_FIELD_TYPES = [
  'text',
  'email',
  'password',
  'url',
  'textarea',
  'number',
  'date',
  'time',
  'datetime',
  'checkbox',
  'switch',
  'slider',
  'rating',
  'select',
  'combobox',
  'multiselect',
  'checkboxgroup',
  'phone',
  'currency',
  'color',
];
